import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { SharedCampaignContext } from '../../../../contexts/Advertiser/SharedCampaignContext'
import { useSidebarCollapse } from '../../../../contexts/SidebarCollapseContext'
import BudgetDetailsPanel from '../../../ProjectManager/Campaign/CampaignPageParts/BudgetTableParts/BudgetDetailsPanel'
import { mergeActiveScenarios } from '../../../ProjectManager/Campaign/CampaignPageParts/BudgetTableParts/mergeActiveScenarios'
import Overview from '../../../ProjectManager/Campaign/CampaignPageParts/BudgetTableParts/Overview'
import {
  advertiserShareFallbackPath,
  isBudgetTableShared,
} from '../shareScenarioVisibility'

export default observer(function BudgetTable() {
  const { campaignScenarios, isLoading, campaign, influencers, authentications } = useContext(SharedCampaignContext)
  const { isCollapsed } = useSidebarCollapse()
  const { id } = useParams()

  const primaryScenario = campaignScenarios[0]
  const activeScenarios = campaignScenarios.filter(s => s.active)
  const mergedScenario = mergeActiveScenarios(activeScenarios)

  if (!isLoading && !isBudgetTableShared(campaign)) {
    return (
      <Navigate
        to={`/advertiser/campaign_share/${id}/${advertiserShareFallbackPath({ scenario: primaryScenario, campaign })}`}
        replace
      />
    )
  }

  return (
    <div className={`pt-14 mr-8 dark:bg-rb-dark-mode-background transition-all duration-300 ${isCollapsed ? 'ml-16' : 'ml-56'}`} style={{ minWidth: '82vw' }}>
      <Overview campaignScenario={mergedScenario} readOnly campaign={campaign} />
      <div className="mt-4 rounded-3xl bg-white dark:bg-rb-dark-mode-background p-4">
        <p className="font-bold text-xl dark:text-white mb-4">Budget Details</p>
        {activeScenarios.map((campaignScenario, index) => (
          <div key={campaignScenario.id} className={index === 0 ? '' : 'mt-6 pt-6 border-t-1 border-border-primary dark:border-rb-dark-mode-lighter'}>
            {activeScenarios.length > 1 && (
              <p className="font-bold text-lg dark:text-white mb-4">{campaignScenario.name}</p>
            )}
            <BudgetDetailsPanel
              campaignScenario={campaignScenario}
              readOnly
              campaign={campaign}
              influencers={influencers}
              authentications={authentications}
            />
          </div>
        ))}
      </div>
    </div>
  )
})
